import audioEffect from '~/assets/mp3/light_switches.mp3';
import { useAudioEffect } from './useAudioEffect';

export function useLightSwitchesAudioEffect() {
  return useAudioEffect(audioEffect);
}
